// Site settings, read from the build environment (.env.local, or Cloudflare Pages
// environment variables). See .env.example. With no Supabase keys the site runs in
// demo mode: the same features, with the data kept in this browser only.
const env = import.meta.env;

export const config = {
  supabaseUrl: (env.VITE_SUPABASE_URL ?? '').trim(),
  supabaseAnonKey: (env.VITE_SUPABASE_ANON_KEY ?? '').trim(),
  siteName: (env.VITE_SITE_NAME ?? '').trim() || 'UCO Collect',
  dataStartsFrom: (env.VITE_DATA_STARTS_FROM ?? '').trim() || '2026-05-01',
};

export type Mode = 'supabase' | 'local';
export const mode: Mode = config.supabaseUrl && config.supabaseAnonKey ? 'supabase' : 'local';
export const isDemo = mode === 'local';
export const APP_VERSION = '2.0 · React';
